import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import VitaIcon from '@/components/UI/VitaIcon.vue'

interface Props {
  // Положение меню относительно смены, приходит из VitaShiftControl
  position: string
  canDelete: boolean
  canUpdate: boolean
  canCopy: boolean
  canInfo: boolean
  // Идёт запрос, действия недоступны
  disabled: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VitaShiftMenuDialog',
  props: {
    position: {},
    canDelete: { type: Boolean },
    canUpdate: { type: Boolean },
    canCopy: { type: Boolean },
    canInfo: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ['delete', 'update', 'copy', 'info'],
  setup(__props: any, { emit: __emit }) {



const emit = __emit

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["menu-dialog", [__props.position]])
  }, [
    _createElementVNode("ul", null, [
      (__props.canDelete)
        ? (_openBlock(), _createElementBlock("li", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('delete'))),
            class: _normalizeClass({ disabled: __props.disabled }),
            "data-qa": "shift-control-menu-item-cancel"
          }, [
            _createVNode(VitaIcon, { name: "cross-red" }),
            _cache[4] || (_cache[4] = _createElementVNode("span", null, "Отменить", -1))
          ], 2))
        : _createCommentVNode("", true),
      (__props.canUpdate)
        ? (_openBlock(), _createElementBlock("li", {
            key: 1,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('update'))),
            class: _normalizeClass({ disabled: __props.disabled }),
            "data-qa": "shift-control-menu-item-edit"
          }, [
            _createVNode(VitaIcon, { name: "pencil" }),
            _cache[5] || (_cache[5] = _createElementVNode("span", null, "Редактировать", -1))
          ], 2))
        : _createCommentVNode("", true),
      (__props.canCopy)
        ? (_openBlock(), _createElementBlock("li", {
            key: 2,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('copy'))),
            "data-qa": "shift-control-menu-item-copy"
          }, [
            _createVNode(VitaIcon, { name: "copy" }),
            _cache[6] || (_cache[6] = _createElementVNode("span", null, "Копировать", -1))
          ]))
        : _createCommentVNode("", true),
      (__props.canInfo)
        ? (_openBlock(), _createElementBlock("li", {
            key: 3,
            onClick: _cache[3] || (_cache[3] = ($event: any) => (emit('info'))),
            class: _normalizeClass({ disabled: __props.disabled }),
            "data-qa": "shift-control-menu-item-info"
          }, [
            _createVNode(VitaIcon, { name: "pencil-edit" }),
            _cache[7] || (_cache[7] = _createElementVNode("span", null, "Информация о смене", -1))
          ], 2))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})